import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/technologicalInnovation',
    meta: { title: '技术创新' },
    component: Layout,
    redirect: '/technologicalInnovation/list',
    children: [
      {
        path: 'list',
        meta: { title: '技术创新', activeMenu: '/technologicalInnovation' },
        component: () => import('@/views/technologicalInnovation/TechnologicalInnovation.vue')
      },
      {
        path: 'detail',
        meta: { title: '技术创新详情', activeMenu: '/technologicalInnovation' },
        component: () => import('@/views/technologicalInnovation/TechnologicalInnovationDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增技术创新', activeMenu: '/technologicalInnovation' },
        component: () => import('@/views/technologicalInnovation/TechnologicalInnovationAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑技术创新', activeMenu: '/technologicalInnovation' },
        component: () => import('@/views/technologicalInnovation/TechnologicalInnovationAdd.vue')
      }

    ]
  }

]
